import React from "react"
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux"

import Component from  "../components/forgotPassword/resetPassword"
import Socket from  "../components/socket"

import store from "../store"

const app = document.getElementById("root")
const root = createRoot(app);
root.render(
    <Provider store={store}>
        <div>
            <Socket />
            <Component />
        </div>
    </Provider>,
);